import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { NotificationChannel } from './notification';

/** POST /api/CronJob/Save -> CronJobRequest */
export interface CronJobRequest {
  id: number;
  jobName: string;
  channel: NotificationChannel;
  cronExpression: string;
  recipient: string;
  subject?: string | null;
  body: string;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class CronJobService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/CronJob`;

  getAll() {
    return this.http.get(`${this.baseUrl}/GetAll`);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/GetById`, { params: { id } });
  }

  save(job: CronJobRequest) {
    return this.http.post(`${this.baseUrl}/Save`, job);
  }

  toggleActive(id: number, isActive: boolean) {
    return this.http.post(`${this.baseUrl}/ToggleActive`, {}, { params: { id, isActive } });
  }

  delete(id: number) {
    return this.http.get(`${this.baseUrl}/Delete`, { params: { id } });
  }
}
